import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '7rem', fontWeight: 800, color: '#e5e7eb', lineHeight: 1 }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ mt: 2, mb: 1, fontWeight: 700, color: '#111827' }}>
        Page not found
      </Typography>
      <Typography variant="body2" sx={{ color: '#6b7280', mb: 4 }}>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Button variant="contained" onClick={() => navigate(-1)} sx={{ mr: 1 }}>
        Go Back
      </Button>
      <Button variant="outlined" onClick={() => navigate('/dashboard')}>
        Dashboard
      </Button>
    </Box>
  );
};

export default NotFound;
